import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FacebookUserModel } from '../../../models/facebook.user.model';
import { AuthService } from 'angular2-social-login';
import { IdentificationStepsService } from '../../../../payment/services/identification-steps.service';

@Component({
    selector: 'social-login-button-facebook',
    templateUrl: './social-login-button.facebook.component.html',
    styleUrls: ['../../../../payment/payment.component.scss']
})
export class SocialLoginButtonFacebookComponent {
    @Input('disabled') disabled: boolean;
    public allowed = false;

    constructor(
        protected socialAuthService: AuthService,
        protected activatedRoute: ActivatedRoute,
        protected identificationStepsService: IdentificationStepsService
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe((data) => {
            this.allowed = this.isAllowed(data);
        });
    }

    /**
     * Verify if facebook login is allowed
     **/
    private isAllowed(data) {
        return data['checkout.identification.login.social_network.facebook'] !== undefined
            && data['checkout.identification.login.social_network.facebook'] !== null
            && data['checkout.identification.login.social_network.facebook'] === '1';
    }

    /**
     * Call Facebook login.
     * */
    public fbLogin() {
        window.location.href='/ecommerce/identification/to-janus/facebook';
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/components/social-login-button/facebook/social-login-button.facebook.component.ts